import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import { ThemeProvider } from "@mui/styles";
import dayjs from 'dayjs';
import React, { Component } from "react";
import NumberFormat from "react-number-format";
import { Link } from "react-router-dom";
import Select from "react-select";
import CircularLoading from "../components/CircularLoading";
import "../styles/style.css";
import theme from "../styles/theme";
import { OrderStatus } from '../utils/Validation';

import InfiniteScroll from "../components/InfiniteScroll";
import { GetAddressLine2 } from "../services/Address";
import { GetRole, GetToken, GuestLogin, Me, RefreshSession, SetToken, SetUser } from "../services/Session";
import { GetOrder } from "../services/Transaction";

const BackIcon = "/assets/svg/back.svg";
const FilterIcon = "/assets/svg/filter.svg";

class TransactionList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      attempt: 0,
      count: 0,
      page: 0,
      per_page: 0,
      total_pages: 0,
      hasMorePage: true,
      isOpenFilter: false,
      startDate: "",
      endDate: "",
      raw_type_filter: [],
      raw_status_filter: [],
      raw_sort_filter: [],
      filters: {
        sorts: "-created_at",
      },
      load: false,
      results: []
    };
  }

  componentDidMount = () => {
    this.handleGetData()
  }

  handleGetData = () => {
    if (GetRole().id >= 2) {
      this.handleGetOrder({ page: this.state.page + 1, ...this.state.filters });
    } else {
      this.props.history.push("/login");
    }
  };

  handleGetOrder(q) {
    this.setState({
      load: true
    })
    GetOrder(q)
      .then(res => {
        this.setState({
          count: res.data.count,
          page: res.data.page_context
            ? res.data.page_context.page
            : this.state.page,
          per_page: res.data.page_context
            ? res.data.page_context.per_page
            : this.state.per_page,
          total_pages: res.data.page_context
            ? res.data.page_context.total_pages
            : this.state.total_pages,
          hasMorePage:
            res.data.page_context &&
              res.data.page_context.page < res.data.page_context.total_pages
              ? true
              : false,
          results: [...this.state.results, ...res.data.results],
          load: false
        });
      })
      .catch(err => {
        if (err.response) {
          if (err.response.status === 401) {
            if (GetToken().refresh_token !== null) {
              RefreshSession();
              setTimeout(this.handleGetOrder(q), 3000)
            } else {
              this.handleLogout();
            }
          } else if (
            err.response.data.error &&
            err.response.data.error &&
            err.response.data.error.message
          ) {
            alert(err.response.data.error.message);
          } else {
            alert("gagal terhubung ke server");
          }
        } else {
          this.handleLogout();
        }
      });
  }

  handleLogout = () => {
    GuestLogin().then(res => {
      Me(SetToken(res.data.token).access_token).then(res => {
        SetUser(res.data);
        setTimeout(this.props.history.push("/"), 3000);
      });
    });
  };

  handleScrollDown = () => {
    if (this.state.hasMorePage) {
      this.setState({ hasMorePage: false });
      this.handleGetData();
    }
  };

  openFilter = () => {
    this.setState({ isOpenFilter: true });
  };

  closeFilter = () => {
    this.setState({ isOpenFilter: false });
  };

  resetFilter = () => {
    this.setState({
      isOpenFilter: false,
      raw_type_filter: [],
      raw_status_filter: [],
      'created_at.$gte': undefined,
      'created_at.$lt': undefined,
      'payment.paid_at.$gte': undefined,
      'payment.paid_at.$lt': undefined,
      'customer.name.$ilike': undefined,
      'customer.phone.$ilike': undefined,
      'customer.email.$ilike': undefined,
      'customer.virtual_account.$ilike': undefined,
      'delivery_service.courier_service.name.$ilike': undefined,
      'delivery_service.destination_address.contact_person.$ilike': undefined,
      'delivery_service.destination_address.phone.$ilike': undefined,
      'delivery_service.destination_address.complete.$ilike': undefined,
      raw_sort_filter: [],
      filters: {
        sorts: "-created_at",
      },
    });

    this.handleGetOrderFilter({ sorts: '-created_at' });
  };

  applyFilter = () => {
    this.setState({
      isOpenFilter: false
    });

    this.handleGetOrderFilter(this.state.filters);
  }

  handleGetOrderFilter(q) {
    GetOrder(q)
      .then(res => {
        this.setState({
          count: res.data.count,
          page: res.data.page_context
            ? res.data.page_context.page
            : this.state.page,
          per_page: res.data.page_context
            ? res.data.page_context.per_page
            : this.state.per_page,
          total_pages: res.data.page_context
            ? res.data.page_context.total_pages
            : this.state.total_pages,
          hasMorePage:
            res.data.page_context &&
              res.data.page_context.page < res.data.page_context.total_pages
              ? true
              : false,
          results: res.data.results
        });
      })
      .catch(err => {
        if (err.response) {
          if (err.response.status === 401) {
            if (GetToken().refresh_token !== null) {
              RefreshSession();
              setTimeout(this.handleGetOrderFilter(q), 3000)
            } else {
              this.handleLogout();
            }
          } else if (
            err.response.data.error &&
            err.response.data.error &&
            err.response.data.error.message
          ) {
            alert(err.response.data.error.message);
          } else {
            alert("gagal terhubung ke server");
          }
        } else {
          this.handleLogout();
        }
      });
  }

  handleChangeFilterOption = (selectedOptions, filtername) => {
    if (filtername === 'type' || filtername === 'status') {
      const selected = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
      const fRaw = (filtername === 'type') ? 'raw_type_filter' : 'raw_status_filter';
      const fName = (filtername === 'type') ? 'type.$in' : 'status.$in';
      this.setState({
        [fRaw]: selectedOptions,
        filters: {
          ...this.state.filters,
          [fName]: selected.toString()
        }
      })
    } else if (filtername === 'created_at.$gte' || filtername === 'created_at.$lt' || filtername === 'payment.paid_at.$gte' || filtername === 'payment.paid_at.$lt') {
      const fValue = (filtername === 'created_at.$gte' || filtername === 'payment.paid_at.$gte') ? selectedOptions.target.value : dayjs(selectedOptions.target.value).add(1, 'days').format('YYYY-MM-DD');
      this.setState({
        [filtername]: selectedOptions.target.value,
        filters: {
          ...this.state.filters,
          [filtername]: fValue,
        }
      })
    } else if (filtername === 'sort') {
      this.setState({
        raw_sort_filter: selectedOptions,
        filters: {
          ...this.state.filters,
          sorts: selectedOptions.value
        }
      })
    } else {
      this.setState({
        [filtername]: selectedOptions.target.value,
        filters: {
          ...this.state.filters,
          [filtername]: '%' + selectedOptions.target.value + '%',
        }
      })
    }
  }

  filterDialog = () => {
    const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) }
    return (
      <Dialog
        open={this.state.isOpenFilter}
        onClose={this.closeFilter}
        aria-labelledby="form-dialog-title"
        className="dialog-filter"
        style={{ height: "100%" }}
      >
        <DialogTitle id="form-dialog-title">Filter</DialogTitle>
        <DialogContent>
          <div className="center" style={{ width: 240, paddingTop: 0, paddingBottom: 10, fontFamily: 'Open Sans' }}>
            <Select
              styles={selectStyles}
              isMulti
              placeholder="Tipe"
              isSearchable={true}
              value={this.state.raw_type_filter}
              onChange={(opt) => this.handleChangeFilterOption(opt, 'type')}
              options={[
                { value: "certificate", label: "Syahadah" },
                { value: "pre_order", label: "Pre Order" },
                { value: "ready_stock", label: "Ready Stock" },
                { value: "ticket", label: "e-Ticket" },
              ]}
            />
          </div>
          <div
            className="center"
            style={{ width: 240, paddingBottom: 10, fontFamily: 'Open Sans' }}
          >
            <Select
              styles={selectStyles}
              isMulti
              placeholder="Status"
              isSearchable={true}
              value={this.state.raw_status_filter}
              onChange={(opt) => this.handleChangeFilterOption(opt, 'status')}
              options={[
                { value: "paid", label: "Lunas" },
                { value: "awaiting_payment", label: "Menunggu Pembayaran" },
                { value: "expired", label: "Kedaluwarsa" },
                { value: "canceled", label: "Dibatalkan" },
                { value: "rejected", label: "Ditolak" },
                { value: "refunded", label: "Dikembalikan" },
                { value: "packing", label: "Diproses" },
                { value: "shipped", label: "Dikirim" },
                { value: "delivered", label: "Sampai Tujuan" },
              ]}
            />
          </div>
          <div className="center" style={{ width: 240, paddingBottom: 0, fontFamily: 'Open Sans' }}>
            <TextField
              label="Deskripsi"
              defaultValue={this.state['description.$ilike']}
              onChange={(opt) => this.handleChangeFilterOption(opt, 'description.$ilike')}
              size="small"
              variant="outlined"
              style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 10 }}
            />
          </div>
          <div className="center" style={{ width: 240, paddingTop: 0, paddingBottom: 10, fontFamily: 'Open Sans' }}>
            <div style={{ paddingTop: 10, paddingBottom: 10 }}>Tanggal Buat</div>
            <TextField
              label="Dari"
              type="date"
              defaultValue={this.state['created_at.$gte']}
              onChange={(opt) => this.handleChangeFilterOption(opt, 'created_at.$gte')}
              size="small"
              variant="outlined"
              style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 10, marginBottom: 10 }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              label="Hingga"
              type="date"
              defaultValue={this.state['created_at.$lt']}
              onChange={(opt) => this.handleChangeFilterOption(opt, 'created_at.$lt')}
              size="small"
              variant="outlined"
              style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 10 }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <div style={{ paddingTop: 10, paddingBottom: 10 }}>Tanggal Bayar</div>
            <TextField
              label="Dari"
              type="date"
              defaultValue={this.state['payment.paid_at.$gte']}
              onChange={(opt) => this.handleChangeFilterOption(opt, 'payment.paid_at.$gte')}
              size="small"
              variant="outlined"
              style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 10, marginBottom: 10 }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              label="Hingga"
              type="date"
              defaultValue={this.state['payment.paid_at.$lt']}
              onChange={(opt) => this.handleChangeFilterOption(opt, 'payment.paid_at.$lt')}
              size="small"
              variant="outlined"
              style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 10 }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
          {GetRole().id > 2 &&
            <div className="center" style={{ width: 240, paddingTop: 0, paddingBottom: 10, fontFamily: 'Open Sans' }}>
              <TextField
                label="Nama Pelanggan"
                defaultValue={this.state['customer.name.$ilike']}
                onChange={(opt) => this.handleChangeFilterOption(opt, 'customer.name.$ilike')}
                size="small"
                variant="outlined"
                style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 20, marginBottom: 10 }}
              />
              <TextField
                label="Nomor Whatsapp"
                defaultValue={this.state['customer.phone.$ilike']}
                onChange={(opt) => this.handleChangeFilterOption(opt, 'customer.phone.$ilike')}
                size="small"
                variant="outlined"
                style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 20, marginBottom: 10 }}
              />
              <TextField
                label="Email"
                defaultValue={this.state['customer.email.$ilike']}
                onChange={(opt) => this.handleChangeFilterOption(opt, 'customer.email.$ilike')}
                size="small"
                variant="outlined"
                style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 20, marginBottom: 10 }}
              />
              <TextField
                label="Virtual Account"
                defaultValue={this.state['customer.virtual_account.$ilike']}
                onChange={(opt) => this.handleChangeFilterOption(opt, 'customer.virtual_account.$ilike')}
                size="small"
                variant="outlined"
                style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 20, marginBottom: 10 }}
              />
              <TextField
                label="Kurir"
                defaultValue={this.state['delivery_service.courier_service.name.$ilike']}
                onChange={(opt) => this.handleChangeFilterOption(opt, 'delivery_service.courier_service.name.$ilike')}
                size="small"
                variant="outlined"
                style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 20, marginBottom: 10 }}
              />
              <TextField
                label="Nama Penerima"
                defaultValue={this.state['delivery_service.destination_address.contact_person.$ilike']}
                onChange={(opt) => this.handleChangeFilterOption(opt, 'delivery_service.destination_address.contact_person.$ilike')}
                size="small"
                variant="outlined"
                style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 20, marginBottom: 10 }}
              />
              <TextField
                label="Nomor HP Penerima"
                defaultValue={this.state['delivery_service.destination_address.phone.$ilike']}
                onChange={(opt) => this.handleChangeFilterOption(opt, 'delivery_service.destination_address.phone.$ilike')}
                size="small"
                variant="outlined"
                style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 20, marginBottom: 10 }}
              />
              <TextField
                label="Alamat Pengiriman"
                defaultValue={this.state['delivery_service.destination_address.complete.$ilike']}
                onChange={(opt) => this.handleChangeFilterOption(opt, 'delivery_service.destination_address.complete.$ilike')}
                size="small"
                variant="outlined"
                style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 10 }}
              />
            </div>
          }
          <div
            className="center"
            style={{ width: 240, paddingTop: 0, paddingBottom: 100, fontFamily: 'Open Sans' }}
          >
            <Select
              styles={selectStyles}
              placeholder="Urutkan dari yang"
              value={this.state.raw_sort_filter}
              onChange={(opt) => this.handleChangeFilterOption(opt, 'sort')}
              options={[
                { value: "-created_at", label: "Terbaru" },
                { value: "created_at", label: "Terlama" },
              ]}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.resetFilter} color="primary" variant="outlined" style={{ textTransform: 'none' }}>
            Atur Ulang
          </Button>
          <Button onClick={this.applyFilter} color="primary" variant="contained" style={{ textTransform: 'none' }}>
            Terapkan
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  render() {
    const bank_charge = 0
    const { load, results } = this.state
    return (
      <ThemeProvider theme={theme}>
        <div style={{ position: 'relative', maxWidth: '60rem', margin: 'auto' }}>
        <div className="header">
          <Link
            to="/"
            style={{
              position: "absolute",
              height: 60,
              width: 60,
              top: 0,
              left: 0
            }}
          >
            <img alt="icon" src={BackIcon} />
          </Link>
          <div className="center" style={{ marginTop: 20 }}>
            <h3 className="title">Daftar Transaksi</h3>
          </div>
          <div
            style={{
              position: "absolute",
              height: 24,
              width: 60,
              top: 18,
              right: 10,
              cursor: 'pointer',
            }}
          >
            <img alt="icon" src={FilterIcon} onClick={this.openFilter} />
          </div>
        </div>
        <div
          className="header"
          style={{ top: 40, height: 30, textAlign: "center", }}
        >
          <span>
            total: {this.state.count} transaksi
          </span>
        </div>
        {this.filterDialog()}
        <div className="wrapper-extended" style={{ paddingBottom: 0 }} ref={el => (this.container = el)}>
          {results.length === 0 ? <div style={{ margin: '0 auto', display: 'table', padding: '30px' }} ><CircularLoading /> </div> :
            <InfiniteScroll loadDataStatus={load} onReachBottom={this.handleScrollDown}>
              {this.state.results.map(data => {
                return (
                  <div
                    className="order-card"
                    key={data.id}
                    style={{
                      width: 300,
                      height: "auto",
                      padding: 15,
                      textAlign: "left",
                      fontSize: 14,
                    }}
                  >
                    <div className="center" style={{ width: 300 }}>
                    <div style={{ cursor: 'pointer' }} onClick={() => this.props.history.push('/transaksi/' + data.number)}>
                      <div style={{ textAlign: "center" }}>
                        <b>{data.description}</b>
                      </div>
                      <hr />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          paddingBottom: 5
                        }}
                      >
                        <div>Status:</div>
                        <div style={{ textAlign: "right" }}>
                          <b>{OrderStatus[data.status]}</b>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          paddingBottom: 5
                        }}
                      >
                        <div>Nomor Tagihan:</div>
                        <div style={{ textAlign: "right" }}>
                          {data.number}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          paddingBottom: 5
                        }}
                      >
                        <div>Total Tagihan:</div>
                        <div style={{ textAlign: "right", color: '#00BFE6' }}>
                          <b><NumberFormat fixedDecimalScale decimalScale={0} value={data.amount + bank_charge} displayType={"text"} thousandSeparator={"."} decimalSeparator={","} prefix={"Rp "} /></b>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          paddingBottom: 5
                        }}
                      >
                        <div>Dibuat pada:</div>
                        <div style={{ textAlign: "right" }}>
                          {dayjs(data.created_at).format(
                            "D MMM YYYY [Pukul] HH:mm"
                          )}
                        </div>
                      </div>
                      {(data.status !== 'awaiting_payment' && data.status !== 'expired' && data.status !== 'canceled' && data.payment !== undefined && data.payment.paid_at !== undefined) ? (
                        <div style={{ display: "flex", justifyContent: "space-between", paddingBottom: 5 }}>
                          <div>Dibayar Pada:</div>
                          <div style={{ textAlign: "right" }}>
                            {dayjs(data.payment.paid_at).format("D MMM YYYY [Pukul] HH:mm")}
                          </div>
                        </div>
                      ) : (
                        <div style={{ display: "flex", justifyContent: "space-between", paddingBottom: 5 }}>
                          <div>Batas Pembayaran:</div>
                          <div style={{ textAlign: "right" }}>
                            {dayjs(data.expired_at).format("D MMM YYYY [Pukul] HH:mm")}
                          </div>
                        </div>
                      )}
                      <hr />
                      {(GetRole().id > 2 && data.customer !== undefined) &&
                        <div>
                          <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <div>Pelanggan:</div>
                            <div style={{ textAlign: "right" }}>{data.customer.name}</div>
                          </div>
                          <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <div>Nomor HP:</div>
                            <div style={{ textAlign: "right" }}>{data.customer.phone}</div>
                          </div>
                          <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <div>Email:</div>
                            <div style={{ textAlign: "right" }}>{data.customer.email}</div>
                          </div>
                          <hr />
                          {data.delivery_service !== undefined &&
                            <div style={{ paddingBottom: 5 }}>
                              <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <div>Pengiriman:</div>
                                <div style={{ textAlign: "right" }}>{data.delivery_service.courier_service.name}</div>
                              </div>
                              <div>{data.delivery_service.destination_address.contact_person}</div>
                              <div>{data.delivery_service.destination_address.complete}</div>
                              <div>{GetAddressLine2(data.delivery_service.destination_address)}</div>
                              <div>Nomor HP : {data.delivery_service.destination_address.phone}</div>
                            </div>
                          }
                        </div>
                      }
                    </div>
                    {(data.status == 'delivered' || data.status == 'shipped') && (
                      <button className="mt-4 w-full py-2 bg-blue-500 text-white font-bold rounded-md hover:bg-blue-700" onClick={() => this.props.history.push('/beri-penilaian/' + data.number)}>
                        Beri Penilaian
                      </button>
                    )}
                  </div>
                  </div>
                );
              })}
            </InfiniteScroll>
          }
        </div>
        </div>
      </ThemeProvider>
    );
  }
}

export default TransactionList;
